var Config = new (Backbone.Model.extend({
    get: function (name, determinationVector) {
        var names = name.split('.');
        var context = Backbone.Model.prototype.get.call(this, names.shift());
        while ((name = names.shift())) {
            context = context[name];
            if (context === undefined) {
                break;
            }
        }
        if (determinationVector) {
            return context.determinator(determinationVector);
        }
        return context;
    }
}));

Config.set({
    'translation': {},
    'social_sharing': {
        default_image_path: '/images/social.sharing/logo.big.png'
    },
    'MALL': {
        DETAILS_PAGE_ENDPOINTS: {
            PRODUCT: CONTEXT_PATH + '/rewards/product_details',
            DEVICE: CONTEXT_PATH + '/rewards/fitness_devices',
            HOTEL: CONTEXT_PATH + '/hotel_stays/hotel_details',
            determinator: function(options){
                if (options.isDevice){
                    return this.DEVICE;
                }
                if (options.isHotel){
                    return this.HOTEL;
                }
                return this.PRODUCT;
            }
        },
        CART_ENDPOINT: CONTEXT_PATH + '/mall/cart',
        PUT_GOOD_ENDPOINT: CONTEXT_PATH + '/mall/add_to_cart',
        USER_INFO_ENDPOINT: CONTEXT_PATH + '/mall/user_address',
        SET_SHIPPING_ENDPOINT: CONTEXT_PATH + '/mall/add_shipping_address',
        PAYMENT_SERVICE_ENDPOINT: CONTEXT_PATH + '/payment/checkout',
        AMAZON_COM_CA_CARD_DETAILS_ENDPOINT: CONTEXT_PATH + '/mall/amazon_card_history',
        VS_REDEEM_PRIZE_DETAILS_ENDPOINT: CONTEXT_PATH + '/active_rewards_redemption/get_card_link' // '/js/app/_stabs/_VS_REDEEM_PRIZE_DETAILS.json'//
    },
    FITBIT: {
        REDEEM_STATUS_ENDPOINT: CONTEXT_PATH + '/redeem_fitbit/get_fitbit_status',
        REDEEM_MODELS_ENDPOINT: CONTEXT_PATH + '/redeem_fitbit/get_fitbits_config',
        SKIP_REDEEM_DIALOG_ENDPOINT: CONTEXT_PATH + '/home/submitFitbitRedemption',
        CART_ENDPOINT: CONTEXT_PATH + '/mall/cart?redeem_fitbit=1',
        PUT_TO_CART_ENDPOINT: CONTEXT_PATH + '/mall/add_to_cart?redeem_fitbit=1',
        SET_SHIPPING_ENDPOINT: CONTEXT_PATH + '/mall/add_shipping_address?redeem_fitbit=1',
        SET_CONTACTS_ENDPOINT: CONTEXT_PATH + '/mall/add_contact_info?redeem_fitbit=1',
        PAYMENT_SERVICE_ENDPOINT: CONTEXT_PATH + '/payment/checkout?redeem_fitbit=1' //'/js/app/_stabs/_mall_cart.json'
    },
    HEALTHY_FOOD: {
        NUTRI_SAVINGS_STORE_LOOKUP_BY_ZIP: CONTEXT_PATH + '/nutri_savings/storeLookupByZipCode',// '/js/app/_stabs/_NUTRI_SAVINGS_STORE_LOOKUP_BY_ZIP.json', // '/nutri_savings/storeLookupByZipCode/60018',
        NUTRI_SAVINGS_REGISTRATION_STATUS: CONTEXT_PATH + '/healthy_food/initiateNSRegistration',
        WALMART_REGISTRATION_INFO: CONTEXT_PATH + '/home/activation', // '/js/app/_stabs/_WALMART_REGISTRATION_INFO.json',
        WALMART_REGISTRATION_UPDATE: CONTEXT_PATH + '/home/activate', // '/js/app/_stabs/_WALMART_REGISTRATION_UPDATE.json',
        TIPS_ENDPOINT: CONTEXT_PATH + '/vap/news_feeds_healthy_food', // '/js/app/_stabs/_healthy_food_tips.json'//
        STATEMENT_ENDPOINT: CONTEXT_PATH + '/healthy_food/saving_statements', //'/js/app/_stabs/_healthy_food_statement.json'
	    POINTS_SAVING_STATEMENTS_ENDPOINT: CONTEXT_PATH + '/healthy_food/points_saving_statements'
    },
    DIRECT_LINKS: {
        GTV: {
            FITNESS_DEVICES_FITBIT: CONTEXT_PATH + '/learning_center/gtv/link_fitness_devices#fitbit'
        },
        FORMS_AND_WAIVERS: CONTEXT_PATH + '/yourAccount/forms_and_waivers'
    },
    RETAIL_OFFERS: {
        OFFERS_ENDPOINT: CONTEXT_PATH + '/home/get_retail_offers', //'/js/app/_stabs/_home_offers.json',
        ADD_OFFER_ENDPOINT: CONTEXT_PATH + '/home/add_retail_offer', // '/js/app/_stabs/_home_offers_admission.json',
        REMOVE_OFFER_ENDPOINT: CONTEXT_PATH + '/home/remove_retail_offer' // '/js/app/_stabs/_home_offers_removal.json'
    },
    HEALTHY_MIND: {
        ACTIVITIES_ENDPOINT: CONTEXT_PATH + '/home/get_healthy_mind_activities', // '/js/app/_stabs/_home_healthy_minds.json' //,
        INTRO_VIDEO_ENDING_ENDPOINT: CONTEXT_PATH +  '/learning_center/healthymind_intro_video_completion', // '/js/app/_stabs/_healthymind_intro_video_completion.json', //
        HEADSPACE_REDEMPTION_CODE_ENDPOINT: CONTEXT_PATH + '/learning_center/generate_headspace_code' //'/js/app/_stabs/_healthymind_headspace_redemption.json'
    },
    GTV: {
        MANULIFE_PRENATAL_CARE_FORM_ENDPOINT: '//cdn.powerofvitality.com/TVG/Learning_Center/GuideToVitality/MLForm_PrenatalCare.pdf',
        EMPLOYER_WELLNESS_OFFERINGS_ENDPOINT: CONTEXT_PATH + '/employer_benefits/employer_offering_hub', //'/js/app/_stabs/_employerWellnessOfferings.json'
        EMPLOYER_COACHING_AND_LIFESTYLE_GUIDANCE_ENDPOINT:  CONTEXT_PATH +  '/vap/getHubPromotions?promotion_category=coaching_and_lifestyle_guidance',
        EMPLOYER_FINANCIAL_HEALTH_ENDPOINT:  CONTEXT_PATH + '/vap/getHubPromotions?promotion_category=financial_health',
        EMPLOYER_WORKPLACE_PROGRAMS_ENDPOINT:  CONTEXT_PATH + '/vap/getHubPromotions?promotion_category=workplace_programs'
    },
    OBSOLETED_BROWSER_REMINDER_ENDPOINT: CONTEXT_PATH + '/home/skipAbsoletedBrowserReminder',
	EMPLOYER_ALERT: {
		DEFAULT_IMAGE: '//cdn.powerofvitality.com/TVG/Header/default_tag_image.png'
	},
    MEDICATION_ADHERENCE: {
        INTRO_VIDEO_ENDING_ENDPOINT: CONTEXT_PATH +  '/learning_center/medication_adherence_intro_video_completion'
    }
});
